// actions
const SET = "loyaltyItems/SET";
const SET_SELECTED = "loyaltyItems/SET_SELECTED";
const SET_LISTING = "loyaltyItems/SET_LISTING";

const DEFAULT_STATE = {
  listing: [],
  filters: [],
  selected: "",
};

// reducer
const reducer = (state = DEFAULT_STATE, action: any = {}) => {
  switch (action.type) {
    case SET:
      return Object.assign({}, state, { listing: action.listing });
    case SET_SELECTED:
      return Object.assign({}, state, { selected: action.id });
    default:
      return state;
  }
};

export default reducer;

// action creators
export const setListing = (listing: any[]) => ({ listing, type: SET });
export const setSelected = (id: string) => ({ id, type: SET_SELECTED });